import { NewsletterListToolbar } from './NewsletterListToolbar';
import { NewsletterListSearchComponent } from './NewsletterListSearchComponent';

const NewsletterListHeader = () => (
  <div className='card-header border-0 pt-6'>
    <NewsletterListSearchComponent />
    <div className='card-toolbar'>
      <NewsletterListToolbar />
    </div>
  </div>
);

export { NewsletterListHeader };
